import React, { PropsWithChildren, useEffect } from 'react';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { SavedReportDragItemType } from '../constants';

import styles from './saved-report-drag.scss';

interface SavedReportDragProps<T> {
  item: T;
  type: SavedReportDragItemType;
  canDrag: boolean;
}

export const SavedReportDrag = <T extends { sequence: number }>({
  item, type, canDrag, children
}: PropsWithChildren<SavedReportDragProps<T>>) => {

  const [, dragRef, preview] = useDrag({
    canDrag,
    type,
    item,
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  });

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, []);

  return <div ref={dragRef} className={canDrag ? styles.dragable : undefined}>
    {children}
  </div>;
};
